import { formatSnapshotRow, getPortfolioChangesPrompt, stackSnapshots } from "./blotterUtils";


const useBlotter = () => {

    const formatSnapshot = (snapshot) => {
        return formatSnapshotRow(snapshot);
    };

    const generatePrompt = (rows, extraHeaders, ...rest) => {
        return getPortfolioChangesPrompt(rows, extraHeaders, ...rest);
    };

    return {
        formatSnapshot,
        generatePrompt,
        stackSnapshots
    };
};

export default useBlotter;
